import React from 'react';
import { ClockLoader } from 'react-spinners';
import getCSSVars from '../../utils/getCSSVars';

const Preloader = ({ color = '#3498db' }) => {
	return (
		<div className='vh-100 d-flex justify-content-center align-items-center'>
			<ClockLoader
				loading={true}
				size={150}
				sizeUnit={'px'}
				color={getCSSVars('text-set3') || color}
			/>
		</div>
	);
};

export default Preloader;
